




































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		label: {
			type: String,
			required: true
		}
	}
});

@Component
export default class Aide extends Props {
	hoverHelpIcon = 'helpon';
}
